var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("img", {
    attrs: {
      alt: "PayPal",
      src:
        "https://www.paypalobjects.com/webstatic/en_US/i/buttons/PP_logo_h_100x26.png"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }